import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Badge, colors, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { Collapsible } from '@app/components/Collapsible';
import { selectChangePlan, selectConfig, selectCurrentUsage, selectPlanCharacteristics } from '@app/redux';

import { Platform } from '@mfe/shared/schema-types';

import CurrentPlan from '../CurrentPlan';
import DataCap from './DataCap';

import styles from './styles.module.scss';

const CollapsibleCurrentPlan = ({ isHidden }: { isHidden?: boolean }) => {
  const { t } = useTranslation('ChangePlan');

  const {
    data: { monthlyDataCap },
  } = useSelector(selectCurrentUsage);

  const {
    characteristics: { dataCap, name, downloadSpeed },
  } = useSelector(selectPlanCharacteristics);
  const isHibernation = name.toLowerCase().includes('hibernation');

  const { hideBroadbandLabels } = useSelector(selectChangePlan);
  const { platform, isPWA } = useSelector(selectConfig);

  const [isOpen, setIsOpen] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);

  const contentPaddingBottom = (platform !== Platform.Web || isPWA) && !hideBroadbandLabels ? '70px' : 0;
  const hasScrollableContent = !hideBroadbandLabels && isOpen;

  React.useEffect(() => {
    setIsScrollable(hasScrollableContent);
  }, [hasScrollableContent]);

  return (
    <Collapsible
      dataCy="collapsible-current-plan"
      hasBoxShadow={true}
      onToggle={(isDetailsOpen) => {
        setIsOpen(isDetailsOpen);
        setIsScrollable(isDetailsOpen && !hideBroadbandLabels);
      }}
      classNames={{
        details: `${styles['current-plan-collapsible-details']} ${isHidden ? styles['hidden'] : ''}`,
        summary: styles['current-plan-collapsible-summary'],
      }}
      summary={
        <div className={styles['current-plan-summary-content']}>
          <div>
            {downloadSpeed && (
              <Txt component="span" variant="bodyLargeRegular" mr="4px">
                {t('plan.mobileHeader.downloadSpeed', { value: downloadSpeed })}
              </Txt>
            )}
            {dataCap || monthlyDataCap ? (
              <DataCap dataCap={dataCap || monthlyDataCap.toString()} downloadSpeed={downloadSpeed} />
            ) : null}
            {isHibernation && <Txt variant="bodyLargeRegular">{name}</Txt>}
          </div>
          <Badge
            datatype="plan-badge"
            label={name}
            showIcon={false}
            emphasis="heavy"
            theme="light"
            size="small"
            state="infoPrimary"
            style={{ backgroundColor: colors['blue'][700] }}
          />
        </div>
      }
      content={
        <div
          data-scrollable={isScrollable ? 'yes' : 'no'}
          className={styles['collapsible-content']}
          style={{ paddingBottom: contentPaddingBottom }}
        >
          <CurrentPlan isCollapsibleCurrentPlan={true} />
        </div>
      }
    />
  );
};

export default CollapsibleCurrentPlan;
